import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { HttpHeaders } from '@angular/common/http';
import { ReturnStatus } from './returnstatus';

export class Common {

    public static httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    };

    public static url: String = "";
    public static snackBar: MatSnackBar;
    public static emailPattern = '^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$';
    private static HORIZANTAL_POSITION: MatSnackBarHorizontalPosition = 'center';
    private static VERTIVCAL_POSITION: MatSnackBarVerticalPosition = 'top';

    public static generateSnackBar(snackBar: MatSnackBar) {
        this.snackBar = snackBar
    }

    public static changefocus(id: string) {

        document.getElementById(id).focus();
    }

    public static alertmsg(msg: string) {
        alert(msg);
    }

    public static mailValidation(mailId: string): any {
        try {

            if (!/[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}/.test(mailId))
                throw new Error("");
            return new ReturnStatus(true);

        } catch (error) {           
            return new ReturnStatus(false, "Enter Valid Mail Id");
        }
    }





    public static getErrMsg(error: any): string {
        return (<Error>error).message;
    }

    public static openSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
            duration: 2000,
            horizontalPosition: this.HORIZANTAL_POSITION,
            verticalPosition: this.VERTIVCAL_POSITION
        }
        );
    }


    public static closeAutoComplete(control: MatAutocompleteTrigger) {
        if (undefined != control.closePanel()) {
            control.closePanel();
        }
    }

    public static dataURLtoFile(dataurl, filename) {

        var arr = dataurl.toString().split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, { type: mime });
    }

    public static backToTop(stringid: string) {
        document.getElementById(stringid).scrollIntoView();
    }

}
